import { InteractionEvent, type OneTimeTokenVerificationVerifyPayload } from '@logto/schemas';

import api from '../api';

import { experienceApiRoutes, type VerificationResponse } from './const';
import { initInteraction } from './interaction';

export type OneTimeTokenCheckResponse = {
  redirectUri: string;
};

export const signInWithOneTimeToken = async (payload: OneTimeTokenVerificationVerifyPayload) => {
  await initInteraction(InteractionEvent.SignIn);

  return api
    .post(`${experienceApiRoutes.verification}/one-time-token/verify`, {
      json: payload,
    })
    .json<VerificationResponse>();
};

/**
 * Initiates a `ForgotPassword` interaction and verifies the one-time token as the
 * identification method. The emailed token proves the user's identity, so no additional
 * verification code is required before setting a new password.
 *
 * Used by the password reset flow for existing users (`first_screen=reset_password`
 * combined with the `one_time_token` and `login_hint` parameters).
 */
export const resetPasswordWithOneTimeToken = async (
  payload: OneTimeTokenVerificationVerifyPayload
) => {
  await initInteraction(InteractionEvent.ForgotPassword);

  return api
    .post(`${experienceApiRoutes.verification}/one-time-token/verify`, {
      json: payload,
    })
    .json<VerificationResponse>();
};

/**
 * Validate and consume a Logto one-time token (email is resolved from the token
 * row), and return the application's first registered redirect URI.
 */
export const checkOneTimeToken = async (payload: {
  readonly token: string;
  readonly clientId: string;
}) =>
  api
    .post(`${experienceApiRoutes.prefix}/one-time-token/check`, {
      json: payload,
    })
    .json<OneTimeTokenCheckResponse>();
